import { Navigate, Outlet, useLocation } from 'react-router-dom';

function PrivateRoute({ auth }) {
  const location = useLocation();
  return auth ? <Outlet /> : <Navigate to="/" />;
}

export { PrivateRoute };
